<template>
  <div>
    <main>
      <div class="hero_single version_2">
        <div class="opacity-mask" data-opacity-mask="rgba(0, 0, 0, 0.6)" style="background-color: rgba(0, 0, 0, 0.6);">
          <div class="container content-form-banner">
            <div class="row justify-content-center">
              <div class="col-xl-7 col-lg-8 col-md-8">
                <h1>Trải nghiệm &amp; Thưởng thức</h1>
                <p>Nền tảng đa dạng với ưu đãi tốt nhất</p>
                <SearchAddress/>
              </div>
            </div>
            <!-- /row -->
          </div>
        </div>
      </div>
      <!-- /hero_single -->

      <!-- /bg_gray -->

      <!-- /container -->
      <section id="component-factsheet-16" class="c-section c-fectsheet">
        <div class="container-fluid">
          <div class="container content-reason-home">
            <div class="main_title center"><span><em></em></span>
              <h2>Vì sao nên chọn MonMi</h2>
            </div>
            <div class="row c-fectsheet__rows">
              <div class="col-12 col-lg-4 col-md c-fectsheet__item u-text-align__center text-center">
                <picture class="lazy loaded">
                  <source data-srcset="/static/images/image%201.png"
                          srcset="/static/images/image%201.png">
                  <img class="lazy loaded w-100 img-content-reason"
                       data-src="/static/images/image%201.png"
                       alt="Luôn có món ngon bạn thích"
                       src="/static/images/image%201.png"
                       data-was-processed="true">
                </picture>
                <h5>Luôn có món ngon bạn thích</h5>
                <p>Khám phá hàng triệu món ăn từ hàng ngàn đối tác nhà hàng</p>
              </div>

              <div class="col-12 col-lg-4 col-md c-fectsheet__item u-text-align__center text-center">
                <picture class="lazy loaded">
                  <source data-srcset="/static/images/image%202.png"
                          srcset="/static/images/image%202.png">
                  <img class="lazy loaded w-100 img-content-reason"
                       data-src="/static/images/image%202.png"
                       alt="Đặt nhanh, giao cũng siêu nhanh"
                       src="/static/images/image%202.png"
                       data-was-processed="true">
                </picture>
                <h5>Đặt nhanh, giao cũng siêu nhanh</h5>
                <p>Món ngon sẽ được giao nhanh thần tốc đến tận nơi bạn muốn</p>
              </div>


              <div class="col-12 col-lg-4 col-md c-fectsheet__item u-text-align__center text-center">
                <picture class="lazy loaded">
                  <source data-srcset="/static/images/image%203.png"
                          srcset="/static/images/image%203.png">
                  <img class="lazy loaded w-100 img-content-reason"
                       data-src="/static/images/image%203.png"
                       alt="Ủng hộ người Việt"
                       src="/static/images/image%203.png"
                       data-was-processed="true">
                </picture>
                <h5>Ủng hộ người Việt</h5>
                <p>Khi đặt món tại các nhà hàng nhỏ lẻ, bạn đã góp phần giúp các nhà hàng Việt phát triển</p>
              </div>


            </div>
          </div>
        </div>
      </section>

      <section class="container-fluid c-section c-howto steps-monmi" id="howto-54">
        <div class="container">
          <div class="row u-text-align__center div-title-steps">
            <div class="col-12 px-2 px-md-0">
              <div class="main_title center"><span><em></em></span>
                <h2>Cách đặt món trên MonMi</h2>
              </div>
            </div>
          </div>
          <div class="row pt-1 pt-md-5 list-steps">
            <div class="col-12 col-md-6">
              <div class="u-full-width c-howto js-slider-mobile">
                <div class="c-howto__panel o-cursor__pointer js-slider-controller js-toggle" :class="this.index == 1 ? 'active' : ''" @click="clickImage(1)">
                  <div class="body">
                    <div class="row">
                      <div class="col-12 d-flex justify-content-center justify-content-md-start item-steps-home">
                        <h4 class="title u-text-align__center--mobile">1․ Chọn biểu tượng MonMi</h4>
                      </div>
                      <div class="col-12 col-md-11 ml-md-1 ml-lg-2">

                        <p class="info u-text-align__center--mobile">Đó là biểu tượng hình con mèo dễ thương đáng yêu</p>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="c-howto__panel o-cursor__pointer js-slider-controller js-toggle" :class="this.index == 2 ? 'active' : ''"  @click="clickImage(2)">
                  <div class="body">
                    <div class="row">
                      <div class="col-12 d-flex justify-content-center justify-content-md-start item-steps-home">
                        <h4 class="title u-text-align__center--mobile">2․ Chọn món ăn từ danh sách gợi ý của MonMi</h4>
                      </div>
                      <div class="col-12 col-md-11 ml-md-1 ml-lg-2">

                        <p class="info u-text-align__center--mobile">Hoặc bạn có thể tìm món hoặc nhà hàng bạn thích
                          trên thanh tìm kiếm</p>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="c-howto__panel o-cursor__pointer js-slider-controller js-toggle" :class="this.index == 3 ? 'active' : ''"  @click="clickImage(3)">
                  <div class="body">
                    <div class="row">
                      <div class="col-12 d-flex justify-content-center justify-content-md-start item-steps-home">
                        <h4 class="title u-text-align__center--mobile">3․ Điền thông tin của bạn</h4>
                      </div>
                      <div class="col-12 col-md-11 ml-md-1 ml-lg-2">
                        <p class="info u-text-align__center--mobile">Hãy cho MonMi biết nơi bạn muốn nhận món ăn</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="c-howto__panel o-cursor__pointer js-slider-controller js-toggle" :class="this.index == 4 ? 'active' : ''"  @click="clickImage(4)">
                  <div class="body">
                    <div class="row">
                      <div class="col-12 d-flex justify-content-center justify-content-md-start item-steps-home">
                        <h4 class="title u-text-align__center--mobile">4․ Sẵn sàng thưởng thức món ăn</h4>
                      </div>
                      <div class="col-12 col-md-11 ml-md-1 ml-lg-2">
                        <p class="info u-text-align__center--mobile">Tài xế sẽ giao món ăn đến bạn trong ít phút. Sau đó
                          thì măm măm thôi!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6" style="text-align: center">
              <img v-if="this.index == 1" class="img-step" src="/static/images/photo_2022-01-04_23-50-50.jpg" alt="">
              <img v-if="this.index == 2" class="img-step" src="/static/images/hinh%20anh%201.png" alt="">
              <img v-if="this.index == 3" class="img-step" src="/static/images/anh%203.png" alt="">
              <img v-if="this.index == 4" class="img-step" src="/static/images/photo_2022-01-04_23-50-27.jpg" alt="">
            </div>
          </div>
        </div>
      </section>

      <div class="call_section lazy" data-bg="url(/static/images/bg_call_section.jpg)"
           data-was-processed="true"
           style="background-image: url('/static/images/bg_call_section.jpg');">
        <div class="container clearfix">
          <div class="col-lg-5 col-md-6 float-right wow">
            <div class="box_1">
              <h3>Bạn là chủ nhà hàng?</h3>
              <p>Tham gia với chúng tôi để tăng khả năng hiển thị trực tuyến của bạn. Bạn sẽ có cơ hội tiếp cận nhiều
                khách hàng hơn nữa,
                những người đang muốn thưởng thức các món ăn ngon của bạn tại nhà.</p>
              <a href="https://merchant.monmi.vn" class="btn_1">Xem Thêm</a>
            </div>
          </div>
        </div>
      </div>
      <!--/call_section-->

    </main>
  </div>
</template>

<script>
import Header from "../components/Header";
import Foot from "../components/Foot";
import HeaderShop from "../components/Header-Shop";
import SearchAddress from "../components/SearchAddress";

export default {
  name: "Home2",
  data() {
    return {
      index : 1,
      countries: ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia & Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central Arfrican Republic", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cuba", "Curacao", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauro", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre & Miquelon", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "St Kitts & Nevis", "St Lucia", "St Vincent", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks & Caicos", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States of America", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"],
    }
  },
  methods:{
    clickImage(i){
      this.index = i
    }
  },
  components: {SearchAddress, HeaderShop, Foot, Header},

}
</script>



// WEBPACK FOOTER //
// src/pages/Home2.vue